<template>
  <p></p>
  <h4>Short Message Service</h4>
  <div class="disclaimer-modal">
    <p>
      I would like to receive informational texts from Assurant regarding my
      liability policy at the cell phone number I provide below. Informational
      texts may include, but are not limited to: any information regarding my
      policy, notices, cancellation, non-renewal, claims, billing and general
      customer service. The frequency and type of informational texts will be
      determined by Assurant. I must inform Assurant if my cell phone number
      changes. I may choose to stop receiving informational texts anytime by
      replying STOP. Standard message and data rates apply.
    </p>
  </div>
  <p></p>
</template>
